// @flow
import React from 'react'
import I18n from 'i18n-react'
import classNames from 'classnames'

import { IconValueComponent } from '../../../Components'

type TextFilterProps = {
  checked: boolean,
  classNames?: string,
  domain: { name: string, value: string, icon: string, alwaysEnabled?: boolean },
  lgClassesGrid?: boolean,
  onChange: (name: string, checked: boolean) => void,
  parentName?: string,
  textMode: boolean,
  topFilter?: boolean,
}

const IconValueFilter = (props: TextFilterProps) => {
  const handleOnChange = (checked: boolean) => {
    props.onChange(props.domain.name, checked || props.domain.alwaysEnabled || false)
  }

  if (props.textMode) {
    return (props.checked || props.domain.alwaysEnabled)
      ? <div className='d-block d-sm-inline-block pl-4'>
        <strong>{I18n.translate(`filter.values.${props.domain.value}`)}</strong>
      </div> : null
  }

  const id = `filter-${props.parentName || ''}-${props.domain.name}`
  let classes = [props.classNames, 'col-4 col-sm-2 col-xl-4 col-xxl-3 py-2 py-2']
  if (props.topFilter) {
    classes = ['col-4 col-sm-2 col-xl-1 py-2 py-2']
  }

  return (
    <div className={classNames(classes)}>
      <IconValueComponent
        active={props.checked || props.domain.alwaysEnabled || false}
        icon={props.domain.icon}
        id={id}
        name={props.domain.name}
        onChange={handleOnChange}
        value={I18n.translate(`filter.values.${props.domain.name}`)}
      />
    </div>
  )
}

export default IconValueFilter
